import { ApiParameter, patch, post, get } from "@insite/client-framework/Services/ApiService";
import { ADIXtenGetUserDetailsModel, ADIXtenIntegrationModel, ADIXtenIsListNameExistsModel } from "@NA/Types/ApiModels";


export interface ADIXtenIntegrationApiParameter extends ApiParameter {
    Id?: string;
    Type?: string;
    WishListName?: string;
    IsTemp?:boolean;
    ListNameInput?:string;
}

export interface ADIXtenWishListParam extends ApiParameter {    
    wishListName?: string;    
}

const adiXtenUrl = "api/v1/adixtensignup/";
export async function processtoxten(parameter: ADIXtenIntegrationApiParameter) {

    const ListNameInput = (parameter.ListNameInput === undefined || parameter.ListNameInput === "undefined" || parameter.ListNameInput.trim() === '') ? undefined : parameter.ListNameInput;
    if(!parameter.IsTemp)
    {
        parameter.WishListName = ListNameInput;
    }
    const ADIXtenIntegration = await post<ADIXtenIntegrationModel>(`${adiXtenUrl}processtoxten`,
        {
            Id: parameter.Id,
            Type: parameter.Type,
            WishListName: parameter.WishListName,
            IsTemp:parameter.IsTemp,
            ListNameInput:ListNameInput
        } as any);
    return ADIXtenIntegration;
}
export async function getUserDetails() {
    const UserDetails = await get<ADIXtenGetUserDetailsModel>(`${adiXtenUrl}getuserdetails`);
    return UserDetails;
}

export async function isUniqueListName(wishListName: string) {
    const isListNameExists = await get<ADIXtenIsListNameExistsModel>(`${adiXtenUrl}islistnameexist?wishListName=${encodeURIComponent(wishListName)}`);
   // const isListNameExists = await get<ADIXtenIsListNameExistsModel>(`${adiXtenUrl}islistnameexist`);
    return isListNameExists;
}

